import { Controller } from '@hotwired/stimulus';
import fieldsForUtils from '../concerns/fields_for_utils';

export default class extends Controller {
  static targets = ['order', 'destroyButton', 'fields', 'destroyField'];

  initialize() {
    fieldsForUtils(this);
    this.reorder();
  }

  destroyHandler(e) {
    e.preventDefault();
    this.destroyFieldTarget.value = true;
    this.element.classList.add('hidden');
    this.dispatch('close', { detail: this.element });
    this.reorder(e);
  }

  reorder(closeEvent = null) {
    const forms = document.querySelectorAll('[data-controller="cargo-field"]:not(.hidden)');
    this.reorderForms(forms, closeEvent);
  }

  removeController() {
    this.element.dataset.controller = null;
  }
}
